/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Assistant_Activity_Read_ProjectInputs */



/**
* | output |
* | --- |
* | "Read the project summary" |
*
* @param {Assistant_Activity_Read_ProjectInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const assistant_activity_read_project = /** @type {((inputs?: Assistant_Activity_Read_ProjectInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Assistant_Activity_Read_ProjectInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Lire le résumé du projet")
	if (locale === "de") return /** @type {LocalizedString} */ ("Lesen Sie die Projektzusammenfassung")
	if (locale === "it") return /** @type {LocalizedString} */ ("Leggi il riepilogo del progetto")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Ознакомьтесь с кратким описанием проекта.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Lea el resumen del proyecto.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("阅读项目概要")
	if (locale === "ja") return /** @type {LocalizedString} */ ("プロジェクト概要を読む")
	if (locale === "hi") return /** @type {LocalizedString} */ ("परियोजना का सारांश पढ़ें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Leia o resumo do projeto")
	return /** @type {LocalizedString} */ ("Read the project summary")
});